(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["co-privacy-control"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-sic-privacy-open]');
    if (!button || button.disabled) return;
    const status = button.closest('.sic-privacy-control')?.querySelector('[data-sic-privacy-error]');
    if (status) status.hidden = true;

    const banner = window.privacyBanner;
    if (typeof banner?.showPreferences !== 'function') {
      if (status) status.hidden = false;
      return;
    }

    button.disabled = true;
    try {
      await banner.showPreferences();
    } catch {
      if (status) status.hidden = false;
    } finally {
      button.disabled = false;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
